<div class="mobile-header-bar d-lg-none d-flex align-items-center">
  <a class="mobile-header-back-btn" [routerLink]="[link]">
    <i class="material-icons">arrow_back_ios</i>
    <h5 class="mobile-header-title" [class.centered]="!showPoints">{{ title }}</h5>
  </a>
  @if( showPoints){
  <div class="action-wrapper">
    <div class="balance font-size-14 text-white gloss me-1">
      <div class="d-flex align-items-center" *ngIf="loyaltyPointsCard$">
        <i class="material-symbols-outlined me-2">loyalty</i>
        <span class="fw-bold">{{ loyaltyPointsCard$ | async | number : '1.0-0' }}</span>
      </div>
    </div>
    <a class="wallet-btn gloss" [routerLink]="'/rewards/wallet'">
      <i class="material-symbols-outlined">qr_code</i>
    </a>
  </div>

  }
</div>
